import './loaderStyles.css';
export const loaderStyles = "l17li5j3";